<template>
  <div style="display: block" class="modal quick-view-modal" :class="m?'fade-in show':'fade'" role="dialog">

      <div class="vs-sidebar--background" @click="m=false"></div>

      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content" :style="{maxWidth}">
            <div class="modal-body">
                <div class="close-btn close-dark" @click="m=false">
                  <span></span>
                  <span></span>
                </div>
                <h4 class="center" style="padding: 8px;font-size: 1.2rem;margin-bottom: 0;">
                  <slot name="header"></slot>
                </h4>
                <slot name="body"></slot>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
   maxWidth:{
     required: false,
     type: String
   },
    model:{
      type:Boolean,
      default:false
    }
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  watch:{
    model(value){
      if (!value){
        console.log(close)
        this.$emit('close')
      }
    }
  },
  computed: {
    m: {
      get: function() {
        return this.model
      },
      set: function(value) {
        document.body.classList.toggle('modal-open');
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style>
</style>